import React, { useState, useEffect } from 'react';
import { Form } from 'form';
import { Language } from 'src/components/language';
import i18n, { CONFIG } from 'src/locales/localization';
import styles from './styles.module.less';
import logo from 'src/components/icons/hotrema-logo-1.png'
// import { LogoIcon } from 'src/components/icons/logo';

export function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    i18n.init(CONFIG, () => setLoading(false));
  }, []);

  if (loading) {
    return null;
  }

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.row}>
            <div>
              <a
                href="https://hotrema.lt/"
                className={`${styles.box} ${styles.logoWrap}`}
              >
                {/* <LogoIcon className={styles.logo} /> */}
                <img src={logo} alt="logo" className={styles.logo} />
              </a>
            </div>
            <div className={styles.box}>
              <Language />
            </div>
          </div>
        </div>
      </header>
      <Form />
    </div>
  );
}
